<div mat-dialog-content>
    <div class="mainDiv">
           <p mat-dialog-title style="margin: 0 0 10px;width: 400px;font-size: 16px;">Why are you updating this numbers, please mention the reason below.</p>
           <form [formGroup]="formdelet">
            <textarea type="text" placeholder="Remark" required formControlName="remark" maxlength="100" rows="3"
            style="width: 100%;"></textarea>        
       <!-- <textarea type="text" placeholder="Remark" required  formControlName="Remark" maxlength="100" rows="1"style="width: 100%;"></textarea> -->
       <!-- <mat-error *ngIf="marketrateform1.get('Remark').hasError('required')">
                        Please write valid reason.
       </mat-error> -->
        <div style="float: right;margin-top: 10px;margin-bottom: 13px;">
            <button type="submit" mat-button  style="margin-right: 8px;" class="btn btncls" (click)="onSubmits()">Submit</button>
            <button mat-button class="btn btncls" (click)="onNoClick()">Cancel</button>
     </div>
      </form>
    </div>
</div>
<style>
  
.btncls{
  width:78px;
  color: white;
  background-color: #234a90;
}
.mat-dialog-content{
overflow: hidden;
width: 105%;
}

/* 
.
.mat-dialog-container {
    display: block;
    padding: 24px;
    border-radius: 4px;
    box-sizing: border-box;
    overflow: hidden;
    outline: 0;
    width: 93%;
    height: 85%;
    min-height: inherit;
    max-height: inherit;
} */
.mainDiv{
  padding: 10px 20px 10px 20px !important;
}
textarea {
  resize: none;
}
</style>
